import type { FormaRent } from '../core/FormaRent';

/**
 * Мост событий брони: слушает FORMA_BOOKING_DONE из iframe и поднимает его в
 * публичный EventBus виджета.
 *
 * Предзаполнение отсюда УБРАНО намеренно. Раньше iframe постил сюда
 * FORMA_USER_DATA с именем, почтой и телефоном клиента, и виджет складывал их в
 * localStorage сайта-хоста. На витрине партнёра это отдавало ему клиентов
 * тенанта, а прочитать такой localStorage мог любой сторонний скрипт на его
 * странице. Теперь контакты не покидают iframe и хранятся на нашем origin —
 * автоподстановка работает на forma.rent, но не переносится между сайтами.
 *
 * Наружу из iframe уходит только идентификатор брони.
 */
export function installBookingEvents(instance: FormaRent): () => void {
  const cfg = instance._config;
  if (!cfg) return () => {};
  const formaOrigin = new URL(cfg.baseUrl ?? __FORMA_ORIGIN__).origin;

  const messageHandler = (e: MessageEvent): void => {
    if (e.origin !== formaOrigin) return;
    // Дополнительно сверяем e.source с iframe — иначе другой iframe того же origin
    // мог бы эмитить события (best-practice defense-in-depth).
    const iframe = instance._getIframe();
    if (iframe && e.source !== iframe.contentWindow) return;

    const raw: unknown = e.data;
    if (!raw || typeof raw !== 'object') return;
    const msg = raw as { type?: unknown; data?: unknown };

    if (msg.type === 'FORMA_BOOKING_DONE' && msg.data && typeof msg.data === 'object') {
      // Эмитим только если модалка была открыта — защита от левых событий.
      if (!instance.isOpen) return;
      const d = msg.data as Record<string, unknown>;
      instance._bus.emit('booking:done', {
        bookingId: typeof d.bookingId === 'string' ? d.bookingId : '',
      });
    }
  };
  window.addEventListener('message', messageHandler);

  return (): void => {
    window.removeEventListener('message', messageHandler);
  };
}
